import { PlatMap } from '@metservice/platforms-ww-platmap';
import { defaultPlatMapSettings } from '@mono/platmap-default-settings';
import { PlatMapSettings } from '@mono/types/src/platmap';
import { WeatherWidget } from '@mono/types/src/weather-widgets';
import { IntervalChart, defaultIntervalChartSettings } from '@metservice/platforms-ww-interval-chart';
import { IntervalChartSettings } from '@mono/types/src/interval-chart';
import {
    RunwayConditions,
    RunwayRainGauge,
    RunwayWindSpeed,
    defaultRunwayConditionsSettings,
    defaultRunwayRainGaugeSettings,
    defaultRunwayWindSpeedSettings,
} from '@metservice/platforms-runway-widgets';
import { RunwayConditionsSettings, RunwayRainGaugeSettings, RunwayWindSpeedSettings } from '@mono/types/src/runway-widgets';
import { WindBarsSettings, defaultSettings as defaultWindBarsSettings } from '@mono/types/src/weather-widgets/wind-bars-settings';
import { WindBars } from '@mono/ww-wind-bars';
import { ThreatMatrixSettings } from '@mono/types/src/weather-widgets/threat-matrix';
import { ThreatMatrix } from '@mono/ww-threat-matrix';
import { defaultSettings as defaultThreatMatrixSettings } from '@mono/ww-threat-matrix-configurator/src/threat-matrix-default-settings';
import { WindDirectionSettings } from '@mono/types/src/weather-widgets/wind-direction-settings';
import { WindDirection, defaultWindDirectionSettings } from '@mono/ww-wind-direction';
import { WeatherStation, defaultWeatherStationSettings } from '@mono/ww-weather-station';
import { WeatherStationSettings } from '@mono/types/src/weather-widgets/weather-station-settings';
import { AirportDialSettings } from '@mono/types/src/weather-widgets/airport-dial-settings';
import { AirportDial, defaultAirportDialSettings } from '@mono/ww-airport-dial';

const platMap: WeatherWidget<PlatMapSettings> = {
    type: 'platMap',
    Render: PlatMap,
    defaultSettings: defaultPlatMapSettings,
};

const intervalChart: WeatherWidget<IntervalChartSettings> = {
    type: 'intervalChart',
    Render: IntervalChart,
    defaultSettings: defaultIntervalChartSettings,
};

const runwayConditions: WeatherWidget<RunwayConditionsSettings> = {
    type: 'runwayConditions',
    Render: RunwayConditions,
    defaultSettings: defaultRunwayConditionsSettings,
};

const runwayWindSpeed: WeatherWidget<RunwayWindSpeedSettings> = {
    type: 'runwayWindSpeed',
    Render: RunwayWindSpeed,
    defaultSettings: defaultRunwayWindSpeedSettings,
};

const runwayRainGauge: WeatherWidget<RunwayRainGaugeSettings> = {
    type: 'runwayRainGauge',
    Render: RunwayRainGauge,
    defaultSettings: defaultRunwayRainGaugeSettings,
};

const windBars: WeatherWidget<WindBarsSettings> = {
    type: 'windBars',
    Render: WindBars,
    defaultSettings: defaultWindBarsSettings,
};

const threatMatrix: WeatherWidget<ThreatMatrixSettings> = {
    type: 'threatMatrix',
    Render: ThreatMatrix,
    defaultSettings: defaultThreatMatrixSettings,
};

const windDirection: WeatherWidget<WindDirectionSettings> = {
    type: 'windDirection',
    Render: WindDirection,
    defaultSettings: defaultWindDirectionSettings,
};

const weatherStation: WeatherWidget<WeatherStationSettings> = {
    type: 'weatherStation',
    Render: WeatherStation,
    defaultSettings: defaultWeatherStationSettings,
};
const airportDial: WeatherWidget<AirportDialSettings> = {
    type: 'airportDial',
    Render: AirportDial,
    defaultSettings: defaultAirportDialSettings,
};

export const weatherWidgets = [
    platMap,
    intervalChart,
    runwayConditions,
    runwayWindSpeed,
    runwayRainGauge,
    windBars,
    windDirection,
    airportDial,
    weatherStation,
    threatMatrix,
];
export const weatherWidgetTypes = weatherWidgets.map((c) => c.type);
